/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetPermissionsQueryResponse, HierarchiesControllerGetPermissionsPathParams, HierarchiesControllerGetPermissionsQueryParams, HierarchiesControllerGetPermissions401, HierarchiesControllerGetPermissions403 } from "../../models/hierarchiesController/HierarchiesControllerGetPermissions";

function getHierarchiesControllerGetPermissionsUrl(scopeId: HierarchiesControllerGetPermissionsPathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/hierarchies/${scopeId}/permissions` as const }  
  return res
}

/**
 * @description Get all effective permissions for the current user in the scope hierarchy
 * @summary Get effective permissions
 * {@link /api/v1/hierarchies/:scopeId/permissions}
 */
export async function hierarchiesControllerGetPermissions(scopeId: HierarchiesControllerGetPermissionsPathParams["scopeId"], params: HierarchiesControllerGetPermissionsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<HierarchiesControllerGetPermissionsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetPermissions401 | HierarchiesControllerGetPermissions403>, unknown>({ method : "GET", url : getHierarchiesControllerGetPermissionsUrl(scopeId).url.toString(), params, ... requestConfig })  
  return res.data
}